// @ts-nocheck
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Shield } from 'lucide-react';

interface SuperAdminGuardProps {
  children: React.ReactNode;
}

export function SuperAdminGuard({ children }: SuperAdminGuardProps) {
  const { isSuperAdmin } = useAuth();

  // Only super admins can access
  if (!isSuperAdmin) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center max-w-sm mx-auto p-8">
          <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <Shield size={32} className="text-red-400" />
          </div>
          <h2 className="text-lg font-bold text-gray-900 mb-2">دسترسی غیرمجاز</h2>
          <p className="text-sm text-gray-500 leading-relaxed">
            این صفحه فقط برای مدیران سیستم قابل دسترسی است.
          </p>
          <button
            onClick={() => window.history.back()}
            className="mt-4 btn-secondary text-sm"
          >
            بازگشت
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
